import React from 'react';
import styled from 'styled-components';
import LandlordLogo from 'components/shared/LandlordLogo';
import Divider from 'components/ui/Divider';

import { getTranslatedString } from 'helpers/i18n';

const StyledContainer = styled.div`
  background: #ffffff;
  border: 1px solid #dfdfdf;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 30px;
`;

const StyledTitleText = styled.div`
  font-weight: 500;
  font-size: 24px;
`;

const StyledBodyText = styled.div`
  font-size: 16px;
  color: #626466;
`;

const StyledDivider = styled(Divider)`
  margin: 10px 40px;
  height: 2px;
  background-color: rgba(0, 0, 0, 0.06);
`;

const ExpiredToken = () => {
  return (
    <StyledContainer>
      <LandlordLogo maxWidth="137px" height="46px" textHeight="30px" />
      <StyledDivider orientation="center" />

      <StyledTitleText>
        {getTranslatedString('maintenanceVendors.tokenExpired.title')}
      </StyledTitleText>
      <StyledBodyText>{getTranslatedString('maintenanceVendors.tokenExpired.body')}</StyledBodyText>
    </StyledContainer>
  );
};

export default ExpiredToken;
